import React from "react";
import Logo from "./images/NPSlogo.png";
import NPDB from "./images/NPDBlogo125.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">

          <ul className="list">
            <li>
              <div className="footer-image-wrapper">
                <img
                  src={Logo}
                  alt="National Park Service Logo"
                  width="70"
                  height="80"
                />
              </div>
            </li>
            <li><p><small>Data from NPS API</small></p> </li>
            <li><small></small></li>
            <li>
            <p><small>
              <a
                  href="https://www.nps.gov/subjects/developer/index.htm"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  nps.gov/
                </a>
              </small></p> 
            </li>
          </ul>

          <div className="copyright">
            <ul className="list">
              <li>
                <div className="footer-image-wrapper">
                  <Link to="/">
                  <img
                    className="footer-logo"
                    src={NPDB}
                    alt="National Park Database Logo"
                    width="85"
                    height="85"
                    style={{ marginLeft: "auto", display: "block" }}
                  />
                  </Link>
                </div>
              </li>
              <li>
                <p><small>&copy; {new Date().getFullYear()} National Park Database</small></p>
              </li>
              <li>
                <p><small>All rights reserved.</small></p> 
              </li>
            </ul>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
